import React from 'react';
import {APIProvider} from '@vis.gl/react-google-maps';
import FetchData from "./Utils/FetchData";
import {RegionalPartner} from "./Interfaces/RegionalPartner";
import {List} from "./Components";

const GOOGLE_MAPS_API_KEY = "AIzaSyCfn302yxwchbZR-hy5m_ppnxoS1Rt4gIc";

type State = {
    data: RegionalPartner[],
    loading: boolean,
    error?: any,
    index: any,
    searchClient: any
}

type Props = {}

class App extends React.Component<Props, State> {
    state: State = {
        loading: true,
        data: [],
        index: null,
        searchClient: null
    }

    componentDidMount() {
        if (this.state.data.length === 0) {
            FetchData()
                .then(response => response.json())
                .then(response => {
                    this.setState({
                        data: response.sort((a:RegionalPartner, b:RegionalPartner) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0)),
                        loading: false
                    })
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                        error: error
                    })
                });
        }
    }

    render() {
        return (
            <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
                {this.state.loading ?
                    <></> :
                    <div className={'regional-partners-app'}>
                        <List data={this.state.data} itemsPerPage={14}/>
                    </div>
                }
            </APIProvider>
        )
    }
}

export default App
